// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import EditorjsController from "./editorjs_controller"
application.register("editorjs", EditorjsController)

import TenantSearchController from "./tenant_search_controller"
application.register("tenant-search", TenantSearchController)

import ArticleSectionNavController from "./article_section_nav_controller"
application.register("article-section-nav", ArticleSectionNavController)

import FlashAlertController from "./flash_alert_controller"
application.register("flash-alert", FlashAlertController)

import CategoryArticleAssignmentController from "./category_article_assignment_controller"
application.register("category-article-assignment", CategoryArticleAssignmentController)

import DeviceHotspotEditorController from "./device_hotspot_editor_controller"
application.register("device-hotspot-editor", DeviceHotspotEditorController)

import DeviceHotspotPreviewController from "./device_hotspot_preview_controller"
application.register("device-hotspot-preview", DeviceHotspotPreviewController)

import DeviceScenesController from "./device_scenes_controller"
application.register("device-scenes", DeviceScenesController)

import WelcomeScreenSlidesController from "./welcome_screen_slides_controller"
application.register("welcome-screen-slides", WelcomeScreenSlidesController)

import WelcomeScreenAssignmentsController from "./welcome_screen_assignments_controller"
application.register("welcome-screen-assignments", WelcomeScreenAssignmentsController)

import PhoneFormatController from "./phone_format_controller"
application.register("phone-format", PhoneFormatController)
